import React from 'react';
import { Box, Text, useColorModeValue, VStack } from '@chakra-ui/react';

const SensorCard = ({ title, description, icon, onClick }) => {
  const boxShadow = useColorModeValue('lg', 'dark-lg');
  const cardBg = useColorModeValue('background', 'secondary'); 
  const textColor = useColorModeValue('text', 'primary');
  const borderColor = useColorModeValue('accent', 'highlight');
  const iconColor = useColorModeValue('accent', 'accentDark'); 

  return (
<Box
     maxW="sm"
     borderWidth="1px"
     borderRadius="lg"
     overflow="hidden"
     p="5"
     bg="background" // Assuming background is a color from your theme
     boxShadow="lg" // Applying a large shadow. You can adjust this value based on your design needs.
     cursor="pointer"
     onClick={onClick}
     _hover={{ boxShadow: "xl" }}
    >
      <VStack spacing={3}>
      <Box color={iconColor}>{icon}</Box>
        <Text fontSize="lg" fontWeight="bold">{title}</Text>
        <Text color="grey" >{description}</Text>
      </VStack>
    </Box>
  );
};

export default SensorCard;